<template>
  <div class="accodion_box_cont payment-other">

    <div class="payment_selte">
      <div class="payTab v2">
        <input
          type="radio"
          class="amwa-radio"
          id="payment-other"
          :checked="otherPayOn"
          @change="toggleRadio($event)"
        >
        <label for="payment-other">다른 결제수단 <span>(자동이체, 신용카드)</span></label>

        <div class="payTab_button_area" :style="styleOtherPayMethodDisplay">
          <a class="payTaba payTab2" :class="classAccount" @click="selectOtherPayAccount">
            자동이체
          </a>
          <a class="payTaba payTab4" :class="classCreditCard" @click="selectOtherPayCard">
            신용카드
          </a>
        </div>

        <div class="payTab_cont_area radio-type1">

          <!-- 계좌 -->
          <div class="pay_cont bankTransfer target_directdebit" v-show="displayOtherPaymentAccount">
            <div class="row card-method">
              <div class="tab-cont-st2">
                <div class="form_group_a">
                  <div class="payment-item-a">
                    <div class="payment-title">
                      <p class="payment-item-title">자동이체 비밀번호</p>
                    </div>

                    <div class="payment-content">
                      <div class="form-item-a">
                        <input
                          autocomplete="off"
                          type="password"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          maxlength="6"
                          class="form_input"
                          placeholder="자동이체 비밀번호 6자리"
                          v-model="depositPassword"
                          @change="onChangeDepositPassword"
                        >
                      </div>
                    </div>
                  </div>

                  <p class="a-pay-backTransfer-txt">* 자동이체는 계좌 등록 후 사용이 가능합니다.</p>
                </div>

                <div class="payment-item-a-info">
                  <a class="title st2" @click="toggleAccordion" :class="classCollapsed">자동이체 안내
                    <span class="hidden">닫기</span>
                  </a>
                </div>

                <div
                  class="panel-collapse detailCont collapse"
                  :class="classAccountInfoIn"
                  :aria-expanded="(!accordionCollapsed).toString()"
                >
                  <div class="panel-body0">
                    <ul class="list-type5">
                      <li>자동이체는 마이페이지에서 계좌 등록 후 사용이 가능합니다.</li>
                      <li>자동이체 결제 후 주문 취소하실 경우 환불시점은 영업일 기준 익일 오후 5시입니다.</li>
                      <li><em>자동이체 가능 은행</em> : 국민, 신한, 우리, SC제일, KEB하나, 농협, 기업, 씨티, 우체국, 유안타증권</li>
                    </ul>

                    <ul class="list-type5">
                      <li><strong>거래가능시간</strong>
                        <ul>
                          <li>- 한도금액을 초과하는 주문 시에는 주문을 나누어 주십시오.</li>
                          <li>- 자동이체는 은행에 따라 새벽시간(00시 ~ 00시 30분)에 거래가 불안정할 수 있습니다.</li>
                          <li>-
                            <span>
                              또한, 월말에는 거래가능시간이라도 은행에 따라 은행영업시간(오후 4시) 이후에 거래가 되지 않을 수 있으니
                              자동이체 이외의 타 결제수단을 이용하시기 바랍니다.
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>SC제일은행, 농협, 우리은행, KEB하나은행, 신한은행, 기업은행, 씨티은행, 우체국 : 한도 없음</li>
                      <li>유안타증권 : 1일 1,000만원 한도</li>
                      <li>KEB하나은행 : 1거래당 1,000만원 한도</li>
                      <li>국민은행 : 1거래당 600만원 한도</li>
                    </ul>

                    <ul class="list-type5">
                      <li>자동이체계좌는 공동사업자1(공동사업자1 & 공동사업자2 인 경우 공동사업자1)의 주민등록번호로 개설된 계좌만 가능합니다.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="pay_cont creditCard"  v-show="displayOtherPaymentCreditCard">
            <div class="row card-method">
              <div class="sub-title-area">
                <span class="sstit">신용/체크카드</span>

<!--                <a class="bt-akl-white mini st2">카드사 혜택보기</a>-->

              </div>

              <div class="form_group_a">
                <div class="payment-item-a">
                  <div class="payment-title">
                    <p class="payment-item-title">카드 종류</p>
                  </div>

                  <div class="payment-content">
                    <div class="form-item-a">
                      <div class="form-col-c">
                        <span class="form_select-default">
                          <select
                            class="form_select"
                            v-model="selectedCreditCard"
                            @change="storeCreditCard"
                          >
                            <option
                              v-for="card in creditCards"
                              :key="card.id"
                              :value="card"
                            >
                              {{ card.name }}
                            </option>
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="payment-item-a">
                  <div class="payment-title">
                    <p class="payment-item-title">할부기간</p>
                  </div>
                  <div class="payment-content">
                    <div class="form-item-a">
                      <div
                        class="form-col-c">
                        <span class="form_select-default">
                          <select
                            class="form_select"
                            :disabled="!canInstalling"
                            v-model="installPlan"
                            @change="storeInstallmentPlan"
                          >
                            <option :value="0" selected="selected">일시불</option>
                            <option v-for="month in months" :key="month" :value="month">{{ month + "개월" }}</option>
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-cont-st2">
                <div class="form_group_b">
                  <div class="payment-item-a cardnum">
                    <div class="payment-title">
                      <p class="payment-item-title">카드번호</p>
                    </div>
                    <div class="payment-content">
                      <div class="form-item-a">
                        <!-- 카드번호1 -->
                        <div class="form-col-c">
                          <input
                            type="text"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            class="form_input"
                            maxlength="4"
                            v-model="cardNumber1"
                            @change="storeCardNumber"
                            ref="cardInput1"
                          >
                        </div>
                        <!-- 카드번호2 -->
                        <div class="form-col-c">
                          <input
                            type="password"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            class="form_input"
                            maxlength="4"
                            v-model="cardNumber2"
                            @change="storeCardNumber"
                            ref="cardInput2"
                          >
                        </div>
                        <!-- 카드번호3 -->
                        <div class="form-col-c">
                          <input
                            type="password"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            class="form_input"
                            maxlength="4"
                            v-model="cardNumber3"
                            @change="storeCardNumber"
                            ref="cardInput3"
                          >
                        </div>
                        <!-- 카드번호4 -->
                        <div class="form-col-c">
                          <input
                            type="text"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            class="form_input"
                            maxlength="4"
                            v-model="cardNumber4"
                            @change="storeCardNumber"
                            ref="cardInput4"
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="payment-item-a">
                    <div class="payment-title">
                      <p class="payment-item-title">유효기간</p>
                    </div>
                    <div class="payment-content">
                      <div class="form-item-a">
                        <div class="form-col-c">
                          <input
                            type="text"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            placeholder="월(MM)"
                            class="form_input a-r"
                            min="1"
                            max="12"
                            @change="storeValidMonth"
                          >
                        </div>
                        <div class="form-col-c">
                          <input
                            type="text"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            placeholder="연(YY)"
                            class="form_input a-r"
                            min="10"
                            max="99"
                            @change="storeValidYear"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form_group_b">
                  <div class="payment-item-a">
                    <div class="payment-title">
                      <p class="payment-item-title">카드비밀번호</p>
                    </div>
                    <div class="payment-content">
                      <div class="form-item-a">
                        <input
                          type="password"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form_input"
                          minlength="2"
                          maxlength="2"
                          placeholder="비밀번호 앞 2자리"
                          @change="storeCardPassword"
                        >
                      </div>
                    </div>
                  </div>

                  <div class="payment-item-a">
                    <div class="payment-title">
                      <p class="payment-item-title">생년월일</p>
                    </div>
                    <div class="payment-content">
                      <div class="form-item-a">
                        <input
                          type="password"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form_input"
                          placeholder="주민번호 앞 6자리"
                          @change="storeAuthNumber"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <payment-receipt
            v-if="displayOtherPaymentAccount"
            :cash-receipt="cashReceipt"
            @update-receipt-info="$emit('update-receipt-info', $event)"
          />


        </div>
      </div>
    </div>
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import { AMWAY_PAY_METHODS, NORMAL_PAYMENT_METHODS, PAYMENT_METHODS } from "@/utils/constants";
import PaymentReceipt from "@/views/order/main/components/Receipt/PaymentReceipt";
import orderApi from '@/apis/order';
import ModalAlert from "@/components/global/ModalAlert";

export default {
  name: "OtherPay",
  components: {
    PaymentReceipt,
    ModalAlert
  },
  watch: {
    cardNumber1(newValue, oldValue) {
      if (newValue.length >= 4) {
        this.$refs.cardInput2.focus();
      }
    },
    cardNumber2(newValue, oldValue) {
      if (newValue.length >= 4) {
        this.$refs.cardInput3.focus();
      }
    },
    cardNumber3(newValue, oldValue) {
      if (newValue.length >= 4) {
        this.$refs.cardInput4.focus();
      }
    },
  },
  methods: {
    toggleRadio(event) {
      let checked = event.target.value;
      console.log("다른결제수단 체크 여부: " + checked);
      this.$emit("toggle-other-pay", checked);
    },
    selectOtherPayAccount() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.NORMAL,
        selectedOtherPayMethod: NORMAL_PAYMENT_METHODS.TRANSFER,
      });
    },
    selectOtherPayCard() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.NORMAL,
        selectedOtherPayMethod: NORMAL_PAYMENT_METHODS.CREDIT_CARD,
      });
    },
    toggleAccordion() {
      this.accordionCollapsed = !this.accordionCollapsed;
    },
    async onChangeDepositPassword() {
      this.$store.commit('account/updatePassword', {
        secret: "",
        validated: false,
      });
      if (this.depositPassword.length === 6) {
        const passwordCheckResponse = await orderApi.checkAutoWithdrawPassword(this.depositPassword);
        if (passwordCheckResponse.error) {
          this.$refs.refAlert.openWithMessage(passwordCheckResponse.error.returnMessage);
        } else {
          this.$store.commit("account/updatePassword", {
            secret: this.depositPassword,
            validated: true,
          });
        }
      }
    },
    storeCreditCard() {
      this.$store.commit("creditcard/creditCardCompanyCode", this.selectedCreditCard.id);
    },
    storeInstallmentPlan() {
      this.$store.commit("creditcard/installmentPlan", this.installPlan);
    },
    storeCardNumber() {
      this.$store.commit("creditcard/cardNumber", this.concatCreditCardNumber);
    },
    storeValidMonth(event) {
      let month = event.target.value;
      console.log(month);
      if (month < 1 || month > 12) {
        alert("1 ~ 12 사이의 값을 입력해야 합니다.");
        return false;
      }
      this.$store.commit("creditcard/validMonth", month);
    },
    storeValidYear(event) {
      let year = event.target.value;
      console.log(year);
      if (year.toString().length !== 2) {
        alert("2자리의 숫자를 입력해야 합니다.");
        return false;
      }
      this.$store.commit("creditcard/validYear", year);
    },
    storeCardPassword(event) {
      let password = event.target.value;
      console.log(password);
      if (password.length !== 2) {
        alert("카드 비밀번호 앞 2자리를 입력하세요.");
        return false;
      }

      this.$store.commit("creditcard/cardPassword", password);
    },
    storeAuthNumber(event) {
      // 카드 소지자 생년월일
      let authNumber = event.target.value;

      if (authNumber.length !== 6) {
        alert("생년월일은 6자로 입력하세요.");
        return false;
      }

      this.$store.commit("creditcard/cardAuth", authNumber);
    }
  },
  computed: {
    concatCreditCardNumber() {
      return this.cardNumber1 + this.cardNumber2 + this.cardNumber3 + this.cardNumber4;
    },
    classAccount() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER && this.otherPayOn
        ? "on" : "";
    },
    classCreditCard() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD && this.otherPayOn
        ? "on": "";
    },
    displayOtherPaymentCreditCard() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD && this.otherPayOn;
    },
    displayOtherPaymentAccount() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER && this.otherPayOn;
    },
    styleOtherPayMethodDisplay() {
      return this.otherPayOn ? { display: "block" } : { display: "none" };
    },
    otherPayOn() {
      return this.paymentMethodInfo.paymentMethod === PAYMENT_METHODS.NORMAL;
    },
    selectedOtherPayMethod() {
      return this.paymentMethodInfo.otherPaymentMethod;
    },
    classCollapsed() {
      return this.accordionCollapsed ? "collapsed" : "";
    },
    classAccountInfoIn() {
      return !this.accordionCollapsed ? "in" : "";
    }
  },
  props: {
    paymentMethodInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          paymentMethod: PAYMENT_METHODS.NORMAL,
          otherPaymentMethod: NORMAL_PAYMENT_METHODS.TRANSFER,
          amwayPayMethod: AMWAY_PAY_METHODS.ACCOUNT,
        }
      }
    },
    canInstalling: {
      type: Boolean,
      default: true,
    },
    cashReceipt: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      accordionCollapsed: true,
      depositPassword: "",
      selectedCreditCard: {id: 'C04', extraCode: '61', authType: 'MPI', name: '현대카드'},
      installPlan: 0,
      cardNumber1: "",
      cardNumber2: "",
      cardNumber3: "",
      cardNumber4: "",
      months: [...Array(13).keys()].filter(i => i >= 2),
      creditCards: [
        {
          id: "C04",
          extraCode: "61",
          authType: "MPI",
          name: "현대카드"
        },
        {
          id: "C0B",
          extraCode: "11",
          authType: "ISP",
          name: "국민카드",
        },
        {
          id: "C03",
          extraCode: "41",
          authType: "MPI",
          name: "신한카드(구LG카드)",
        },
        {
          id: "C02",
          extraCode: "51",
          authType: "MPI",
          name: "삼성카드",
        },
        {
          id: "C09",
          extraCode: "46",
          authType: "ISP",
          name: "광주카드",
        },
        {
          id: "C0G",
          extraCode: "",
          authType: "MPI",
          name: "기타카드",
        },
        {
          id: "C05",
          extraCode: "71",
          authType: "MPI",
          name: "롯데카드",
        },
        {
          id: "C0A",
          extraCode: "31",
          authType: "ISP",
          name: "비씨카드",
        },
        {
          id: "C0C",
          extraCode: "30",
          authType: "ISP",
          name: "산업은행",
        },
        {
          id: "C08",
          extraCode: "34",
          authType: "ISP",
          name: "수협카드",
        },
        {
          id: "C06",
          extraCode: "42",
          authType: "ISP",
          name: "신한(제주)카드",
        },
        {
          id: "C07",
          extraCode: "36",
          authType: "MPI",
          name: "씨티(한미)카드",
        },
        {
          id: "C01",
          extraCode: "21",
          authType: "MPI",
          name: "외환카드",
        },
        {
          id: "C10",
          extraCode: "35",
          authType: "ISP",
          name: "전북카드",
        },
        {
          id: "C11",
          extraCode: "32",
          authType: "MPI",
          name: "하나카드(토스체크카드 포함)",
        },
        {
          id: "C12",
          extraCode: "91",
          authType: "MPI",
          name: "NH농협",
        },
        {
          id: "C14",
          extraCode: "33",
          authType: "MPI",
          name: "우리카드",
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>
